import {QRCodeSVG} from 'qrcode.react';
import React from 'react';
import {Box, useTheme} from '@mui/material';
import {ResursLoading} from '../../components';

export interface BankIDQRCodeProps {
  code: string;
  isLoading?: boolean;
}

const QR_CODE_SIZE = 160;
export const BankIDQRCode: React.FC<BankIDQRCodeProps> = (props) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 1,
        background:
          theme.palette.mode === 'dark'
            ? theme.palette.text.primary
            : undefined,
      }}>
      <Box
        sx={{
          width: QR_CODE_SIZE,
          height: QR_CODE_SIZE,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <BankIDQRCodeInternal {...props} />
      </Box>
    </Box>
  );
};

const BankIDQRCodeInternal: React.FC<BankIDQRCodeProps> = ({
  code,
  isLoading,
}) => {
  if (isLoading) {
    return <ResursLoading />;
  }

  if (!code) {
    return null;
  }

  return <QRCodeSVG value={code} size={QR_CODE_SIZE} />;
};
